import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

function MyQrCode({ value }) {
  return (
    <div>
      <QRCodeSVG 
        value={value} 
        size={200} 
        bgColor="#ffffff" 
        fgColor="#000000" 
        level="H" 
        includeMargin={true} 
      />
    </div>
  );
}

export default MyQrCode;
